import { createAction, props } from '@ngrx/store'
import { PreferredContactEnum, SharedProfile } from './profile.models'
import { HttpErrorResponse } from '@angular/common/http'
import { PaddleRaisePledgesEntity } from 'libs/shared/paddle-numbers/data-access-paddle-raise-pledges/src/lib/+state/paddle-raise-pledges.models'

export const sendVerification = createAction(
  '[Users/API] Send verification',
  props<{
    verification_type: PreferredContactEnum
    profile?: SharedProfile
    phone_number?: string
    email?: string
    code_only?: boolean
  }>(),
)

export const sendVerificationSuccess = createAction('[Users/API] Send verification Success')

export const sendVerificationFailure = createAction(
  '[Users/API] Send verification Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const openAssignPaddleDialog = createAction(
  '[PaddleRaisePledges/API] open assign paddle dialog',
  props<{ pledge: PaddleRaisePledgesEntity }>(),
)
